import axios from "axios";
import { get } from "@/services/axiosUitils";
import {
  clearSessionAndRedirectToLogin,
  hasAuthSession,
} from "@/services/tokenRefresh";

export const GLUCERA_SESSION_VALIDATED_KEY = "glucera_session_validated";

const SESSION_PROBE_PATHS = [
  "/food_scanner/profile/",
  "/food_scanner/food-home-page/",
];

export function isSessionInvalidError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  const status = error.response?.status;
  if (status === 401 || status === 403) return true;
  if (status === 404) {
    const url = error.config?.url ?? "";
    return SESSION_PROBE_PATHS.some((path) => url.includes(path));
  }
  return false;
}

export function clearSessionValidationFlag(): void {
  sessionStorage.removeItem(GLUCERA_SESSION_VALIDATED_KEY);
}

export function markSessionValidated(): void {
  sessionStorage.setItem(GLUCERA_SESSION_VALIDATED_KEY, "1");
}

function isSessionValidated(): boolean {
  return sessionStorage.getItem(GLUCERA_SESSION_VALIDATED_KEY) === "1";
}

/** Log out when the server indicates this account/session no longer exists. */
export function logoutIfSessionInvalid(error: unknown): boolean {
  if (!hasAuthSession() || !isSessionInvalidError(error)) {
    return false;
  }
  clearSessionValidationFlag();
  clearSessionAndRedirectToLogin();
  return true;
}

/**
 * Confirm the logged-in user still exists on the server (e.g. not deleted from DB).
 * Skips the probe when already validated this browser session.
 */
export async function ensureUserSessionExists(): Promise<boolean> {
  if (!hasAuthSession() || isSessionValidated()) return true;

  // Profile is created after assessment — do not probe mid-flow.
  if (localStorage.getItem("glucera_onboarding_complete") !== "true") {
    return true;
  }

  try {
    await get("/food_scanner/profile/", { notifyMessage: false });
    markSessionValidated();
    return true;
  } catch (error) {
    if (logoutIfSessionInvalid(error)) return false;
    return true;
  }
}
